import React, { useEffect, useMemo, useState } from 'react';
import { Button, message, Modal, Tag } from 'antd';
import { connect, useDispatch } from 'react-redux';
import RestHelper from 'utils/RestHelper';
import { isAndroid, isAndroidOrHarmony, isIos, isMac, isMobile, isPc, isPcOrLinux } from 'utils/platform';
import { convertIosModelToProductName } from 'utils/model-convert/ios-model-convert';
import { decodeCsSdkEncodedValue } from 'utils/helper';
import { FieldName, QueryType } from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { VmTypeInt } from 'utils/constants/vm-type';
import { IssueAggregateType } from 'utils/constants/issue-aggregate-type';
import { EnvUtil } from 'utils/env-util';
import { useTranslation } from 'react-i18next';
import { ze } from 'utils/zhEn';
import { useGetState } from 'ahooks';
import { isNotNullish } from 'utils/nullish';
import { actionQuerySavedIssueAiReason } from 'reducers/issue/issueActions';
import useZuStore from 'store/zustand/zustand-store';

const IssueAiAnalysis = (props) => {
  const {
    reduxState,
    issueId,
  } = props;

  const { t } = useTranslation();

  const aiDrawerSlice = useZuStore(state => state.aiDrawer);

  const currentApp = reduxState.app.get('current').toJS();
  const { appId, pid } = currentApp;

  const issueIdToAiReason = reduxState.issue.get('issueIdToAiReason') || {};
  const currentIssueAiReason = issueIdToAiReason[issueId] || {};
  const hasCalculatedReason = currentIssueAiReason.exists;
  const calculatedLabels = currentIssueAiReason?.labels || [];

  const [checking, setChecking] = useState(false);

  function buildIssueUrl() {
    const origin = window.location.origin;
    const m = window.location.pathname.match(
      /^\/crash-reporting\/(crashes|errors|blocks|janks|hangs|metrickit-crash)\/[^/]+\/[^/?#]+/,
    );
    const kind = m?.[1] || 'crashes';
    return `${origin}/crash-reporting/${kind}/${appId}/${issueId}`;
  }

  function buildCrashClawAutoSendText(issueUrl) {
    return ze(
      `请分析这个问题：${issueUrl}

要求：
1. 用 CrashSight MCP 拉取该 issue 的堆栈与上下文，不要向我追问 issueId。
2. 先读已授权仓库清单，按匹配规则 clone/pull 后做源码级分析；匹配不到就说明无法做源码定位，不要假装做过。
3. 最终回复必须包含这两个二级标题（不要改名）：
## 根因结论
## 修复建议`,
      `Please analyze this issue: ${issueUrl}

Requirements:
1. Use CrashSight MCP to fetch this issue's stack and context. Do not ask me for the issueId.
2. Read the authorized repo list first, then clone/pull by matching rules and do source-level analysis. If nothing matches, say you cannot locate the source — do not pretend.
3. The final reply must include these two headings (do not rename):
## Root Cause
## Fix Recommendations`,
    );
  }

  async function onClickStartAnalysis() {
    if (checking) return;
    setChecking(true);
    try {
      if (!EnvUtil.isChinaEnv()) {
        aiDrawerSlice.startChatBotWithIssue(issueId, appId);
        return;
      }
      const rsp = await RestHelper.mustPost('/redir/api/crashclaw/resolveIssueAnalysisRoute', {
        appId,
        issueId,
      });
      const route = rsp?.json?.data || {};
      const action = route.action;
      if (action === 'OPEN_CRASHCLAW' && route.workspaceUid && route.sessionId) {
        aiDrawerSlice.startChatBotWithCrashClaw({
          workspaceUid: route.workspaceUid,
          sessionId: route.sessionId,
        });
        return;
      }
      if (action === 'NEW_CRASHCLAW' && route.workspaceUid) {
        aiDrawerSlice.startChatBotWithCrashClaw({
          workspaceUid: route.workspaceUid,
          autoSendText: buildCrashClawAutoSendText(buildIssueUrl()),
          appId,
          issueId,
        });
        return;
      }
      if (action === 'OPEN_DIFY' || action === 'NEW_DIFY') {
        aiDrawerSlice.startChatBotWithIssue(issueId, appId);
        return;
      }
      aiDrawerSlice.startChatBotWithIssue(issueId, appId);
    } catch (e) {
      console.error('[IssueAiAnalysis] resolveIssueAnalysisRoute failed, fallback to Dify', e);
      aiDrawerSlice.startChatBotWithIssue(issueId, appId);
    } finally {
      setChecking(false);
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {/* { calculatedLabels.length > 0 && <div>{
        calculatedLabels.map((x, i) => <Tag color='geekblue' key={i}>{ x }</Tag>)
      }</div> } */}
      <Button
        style={{
          background:'linear-gradient(120deg,#CE7EF3, #6E7FFD)',
          color:'#fff',
        }}
        loading={checking}
        onClick={onClickStartAnalysis}
      >{ ze('AI分析', 'AI Analysis') }</Button>
    </div>
  );
};


const mapStateToProps = (state, router) => ({
  reduxState: state,
});

export default connect(mapStateToProps)(IssueAiAnalysis);
